import { useHistory } from "react-router-dom";
import { useLoyalty, useTheme } from "../../../../hooks";

const useSpeedShoppingPoints = () => {
  const { themeContext, theme } = useTheme();
  const {
    userPoints,
    mashupnWinOrders,
    getTopLoyaltyList,
    topLoyaltyList,
    getLoyaltyPoints,
  } = useLoyalty();

  const history = useHistory();

  let themeColor = "background";
  let background = theme.colors[themeContext.activeTheme][themeColor];

  return {
    background,
    history,
    userPoints,
    mashupnWinOrders,
    unitPoints: 10,
    getTopLoyaltyList,
    topLoyaltyList,
    getLoyaltyPoints,
  };
};

export default useSpeedShoppingPoints;
